// extracted by mini-css-extract-plugin
module.exports = {"leftArrow":"index_leftArrow_wG0rY"};